import type { PersistedSession } from '@share/domain';

export function filterInterruptedSessions(sessions: PersistedSession[]): PersistedSession[] {
  return sessions.filter(
    (s) =>
      s.status === 'recovering' ||
      s.status === 'transferring' ||
      s.status === 'connecting' ||
      s.status === 'seeding'
  );
}

export function filterPausedReceiveSessions(sessions: PersistedSession[]): PersistedSession[] {
  return sessions.filter(
    (s) => s.status === 'paused' && s.direction === 'receive'
  );
}
